<template>
  <div class="pc-class">
    <div class="pc-class-title">
      <div class="pc-class-word">
        <div class="pc-class-word1">
          <h2>{{ title.module }}词库管理</h2>
          <div>
            <el-button
              @click="isManage = true"
              v-show="isManage == false"
              class="pc-search-btn"
            >
              管理
            </el-button>
            <el-button
              @click="isManage = false"
              v-show="isManage"
              class="pc-search-btn"
            >
              完成
            </el-button>
          </div>
        </div>
        <div class="pc-search">
          <el-form :model="keywordData" :inline="true">
            <el-form-item label="关键词" class="title">
              <el-input v-model="keywordData.keyword"></el-input>
            </el-form-item>
          </el-form>

          <button class="pc-search-btn" @click="search">筛选</button>
        </div>
      </div>
    </div>
    <!-- 分类签管理 -->
    <div class="pc-class-manage">
      <div
        v-for="(item, index) in title.class"
        :key="index"
        class="pc-class-manage-type"
      >
        <div class="pc-class-manage-title">
          <h4>{{ item.name }}</h4>
        </div>

        <ul>
          <li
            v-for="(subtitle, id) in item.subTitles"
            :key="id"
            :class="isManage ? 'managerClass' : ''"
          >
            <span>{{ subtitle.stop_word ? subtitle.stop_word : "" }} </span>
            <i
              v-show="isManage"
              @click="deleteTopic(subtitle.id, item.name)"
              class="el-icon-close"
            ></i>
          </li>
          <li
            @click="addTopic(item.name)"
            class="add-topic"
            v-show="isManage == true"
          >
            <span>添加敏感词</span>
          </li>
        </ul>
      </div>
    </div>

    <DeleteDialog
      @isDelete="isDelete()"
      @isCancel="isCancel"
      :dialogVisible="deleteShow"
      :delContent="delContent"
    />

    <!-- 添加标签的模态框 -->
    <el-dialog :visible.sync="dialogFormVisible">
      <div class="title">
        <p>敏感词</p>
        <el-input v-model="topicArgs.stop_word" label-width="100px"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DeleteDialog from "@/components/componentSet/DeleteDialog";
export default {
  props: { title: Object },
  components: {
    DeleteDialog,
  },
  data() {
    return {
      topicArgs: {
        status: 1,
        type: null,
        english_name: null,
        chinese_name: null,
        id: null,
      },
      keywordData: {
        keyword: "",
      },

      delContent: null,
      isManage: false,
      dialogFormVisible: false,
      deleteShow: false,
    };
  },
  methods: {
    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
    clearTopicArgs() {
      Object.keys(this.topicArgs).forEach((key) => {
        this.topicArgs[key] = null;
      });
      this.topicArgs.status = 1;
    },
    addTopic(name) {
      this.topicArgs.type = name;
      console.log(this.topicArgs);
      this.dialogFormVisible = true;
    },
    // 添加or修改
    confirm() {
      this.$emit(
        this.topicArgs.id ? "updateTopic" : "addTopic",
        this.topicArgs,
        () => {
          this.dialogFormVisible = false;
          this.clearTopicArgs();
        }
      );
    },
    deleteTopic(id, name) {
      this.topicArgs.id = id;
      this.topicArgs.type = name;
      this.deleteShow = true;
    },
    isCancel() {
      this.deleteShow = false;
    },
    isDelete() {
      this.$emit("deleteTopic", this.topicArgs, () => {
        this.deleteShow = false;
        this.clearTopicArgs();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-class {
  box-shadow: $boxshadow;
  padding: 20px 35px 20px;
  margin-top: 40px;
  .pc-class-title {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;
    padding-bottom: 15px;
    > h2 {
      font-size: 20px;
      color: $mainTitle;
      align-self: flex-end;
    }
    .pc-search-btn {
      @include manage-button;
    }
    .pc-class-word {
      width: 100%;
      display: flex;
      flex-direction: column;
      .pc-class-word1 {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
      }
      .pc-search{
                display: flex;
        justify-content: space-between;

      }
    }
  }
  .pc-class-manage {
    margin-top: 20px;
    .pc-class-manage-title {
      display: flex;
      height: 20px;
      h4 {
        font-size: 14px;
        color: $mainTitle;
      }
      .icon-area {
        margin-left: 10px;
        color: $timeBtn;
        cursor: pointer;
      }
      .icon-area:nth-of-type(2) {
        margin-left: 5px !important;
      }
      /deep/ .el-input {
        margin-top: 20px;
        width: auto;
      }
    }
    ul {
      margin-top: 10px;
      display: flex;
      li {
        min-width: 70px;
        text-align: center;
        padding: 8px 21px;
        border: 1px solid $universityBorder;
        background: $universityBackground;
        margin-right: 20px;
        margin-bottom: 20px;
        color: $timeBtn;
        font-family: $english;
        border-radius: 4px;
        .el-icon-close {
          margin-left: 5px;
        }
      }
      .add-topic {
        border: 1px dashed $timeBtn;
        background: none;
        cursor: pointer;
      }
      .managerClass {
        transition: transform 0.3s;
      }
      .managerClass:hover {
        transform: translateY(-10px);
        cursor: pointer;
      }
    }
    .pc-class-manage-type {
      .pc-class-manage-title {
        display: flex;
        h4 {
          font-size: 14px;
          color: $mainTitle;
        }
        .icon-area {
          margin-left: 10px;
          color: $timeBtn;
          cursor: pointer;
        }
        /deep/ .el-input {
          margin-top: 20px;
          z-index: 20;
          width: auto;
        }
      }
      ul {
        flex-wrap: wrap;
        li {
          margin-bottom: 20px;
          span {
            font-size: 14px;
          }
        }
      }
    }
    .addType {
      margin-top: 10px;
      margin-bottom: 20px;
      cursor: pointer;
      .el-icon-circle-plus-outline {
        font-size: 20px;
        color: $blueBtna;
      }
      span {
        font-size: 14px;
        text-align: center;
      }
    }
  }
}

.el-dialog__body {
  display: flex;
  justify-content: center;
}
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .title {
    display: flex;
    margin-bottom: 10px;
    p {
      font-size: 14px;
      font-weight: 600;
      line-height: 40px;
      flex-shrink: 0;
      margin-right: 20px;
    }
  }
  .el-dialog__footer {
    padding: 10px 25% 30px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
      .el-button--default:hover {
        span {
          color: $blueBtna;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/content/components/SensitiveWordManagementTable.vue